import { Search } from "lucide-react";
import { cn } from "@/lib/utils";
import { Input } from "@/components/ui/input";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
}

const SearchInput = ({
  value,
  onChange,
  placeholder = "Search...",
  className,
  inputClassName,
}: SearchInputProps) => {
  return (
    <div className={cn("relative flex-1 sm:max-w-[280px]", className)}>
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={cn("pl-9", inputClassName)}
      />
    </div>
  );
};

export default SearchInput;
